import { useEffect } from 'react';

import { useParams } from 'react-router';

import { AmplitudeProductEvent } from '@cfa/pathway-fe-shared';

import Constants from '../../constants/index';

import PdfDownload from './PdfDownload';

import { useAmplitudeTrack } from '@/amplitude/useAmplitude';

const PrintView = () => {
  const params = useParams<{ documentId: string }>();
  const { documentId } = params;
  const track = useAmplitudeTrack();

  useEffect(() => {
    track(AmplitudeProductEvent.DOCUMENT_PRINT, {
      document_id: documentId ?? 'empty',
      datetime: new Date().toLocaleString(),
      is_native: window.native.isNative,
    });
  }, [track, documentId]);

  return (
    <div className="bg-surface-gray absolute top-0 left-0 z-2 min-h-screen w-screen">
      <PdfDownload
        url={`${Constants.PATHWAY_API_URL}/${Constants.PATHWAY_API.BINARY_PATH_NAME}/${documentId}`}
      />
    </div>
  );
};

export default PrintView;
